import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=79693d88&"
import script from "./perfil.vue?vue&type=script&lang=js&"
export * from "./perfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports